
export default context => {
    $('[data-type][data-action="uploadImage"],.image-editor-container', context).each(function() {
        const type = $(this).data('type')
        if (window.sizes[type]) {
            $(this).css('aspect-ratio', window.sizes[type].containerRatio)
        }
    })
}
